import { render, staticRenderFns } from "./AstroProspectButton.vue?vue&type=template&id=1f4b0225&"
import script from "./AstroProspectButton.vue?vue&type=script&lang=js&"
export * from "./AstroProspectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports